import { defineComponent as _defineComponent } from 'vue'
import { useImage } from '@/shared/composables/image'
import BKImage from '@/components/AppShared/BKImage.vue'
import { Studio } from '@/modules/Studios/types'

interface IProps {
  studio: Studio
}


export default /*#__PURE__*/_defineComponent({
  __name: 'StudioMapChip',
  props: {
    studio: null
  },
  setup(__props: any) {

const props = __props as {
  studio: Studio
};

const { getImageById } = useImage()


const srcImg = getImageById(props.studio.image, 190, 190, 'org')

return { __sfc: true,getImageById, props, srcImg, BKImage }
}

})